import React from 'react';

import { Modal as AntdModal } from 'antd';

import { TypeAutoriteFourriereDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  typeAf: TypeAutoriteFourriereDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  typeAf,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <AntdModal
      visible={visible}
      onCancel={close}
      footer={null}
      destroyOnClose={true}
      width={BaseModalWidthUtils.xLargeWidth}
      maskClosable={false}
      className="modalDetails"
    >
      <FieldDisplay label={LABEL_ID_CORRELATION} value={typeAf.idCorrelation} />
      <FieldDisplay label="Type" value={typeAf.type} />
      <FieldDisplay
        label="Libellé notification"
        value={typeAf.displayedText}
        additionalValueClassName="multiLineValue"
      />
      <FieldDisplay
        label="Code typologie DNID Niveau 1"
        value={typeAf.alienationCodeTypologieNiveau1}
      />
      <FieldDisplay
        label="Code typologie DNID Niveau 2"
        value={typeAf.alienationCodeTypologieNiveau2}
      />
    </AntdModal>
  );
}

export default ModalDetails;
